"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRow = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const flexbox_1 = require("../flexbox");
exports.StyledRow = (0, styled_components_1.default)(flexbox_1.Flexbox)(({ customStyles, noWrap }) => {
    return (0, styled_components_1.css) `
    flex-wrap: ${noWrap ? 'nowrap' : 'wrap'};
    margin: 0;
    padding: 0;
    gap: 40px;
    @media (max-width: ${`${theme_1.grid.vpBreakpoints.VPS}px`}) {
      gap: 32px;
    }
    ${customStyles !== null && customStyles !== void 0 ? customStyles : {}}
  `;
});
//# sourceMappingURL=styles.js.map